(function () {
  var root = document.getElementById('notb-chords');
  if (!root) return;
  var L = root.getAttribute('data-lang') === 'en' ? 'en' : 'nl';
  var T = {
    nl: { play: 'Afspelen', stop: 'Stop', copied: 'Gekopieerd', copy: 'Kopieer akkoorden' },
    en: { play: 'Play', stop: 'Stop', copied: 'Copied', copy: 'Copy chords' }
  }[L];

  var SHARP = ['C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B'];
  var FLAT = ['C', 'Db', 'D', 'Eb', 'E', 'F', 'Gb', 'G', 'Ab', 'A', 'Bb', 'B'];
  var FLAT_KEYS = { maj: [5, 10, 3, 8, 1, 6], min: [2, 7, 0, 5, 10, 3] };
  var SCALE = { maj: [0, 2, 4, 5, 7, 9, 11], min: [0, 2, 3, 5, 7, 8, 10] };
  var Q = { M: [0, 4, 7], m: [0, 3, 7], dim: [0, 3, 6], '7': [0, 4, 7, 10], maj7: [0, 4, 7, 11], m7: [0, 3, 7, 10] };
  var SUF = { M: '', m: 'm', dim: 'dim', '7': '7', maj7: 'maj7', m7: 'm7' };
  var ROMAN = ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII'];
  var P = {
    min: {
      dark: [[[0,'m'],[5,'M'],[2,'M'],[6,'M']], [[0,'m'],[3,'m'],[5,'M'],[4,'M']], [[0,'m'],[0,'m'],[5,'M'],[4,'m']], [[0,'m'],[1,'dim'],[4,'M'],[0,'m']], [[0,'m'],[6,'M'],[5,'M'],[6,'M']], [[0,'m'],[3,'m'],[0,'m'],[4,'M']], [[0,'m'],[5,'M'],[3,'m'],[4,'M']]],
      sad: [[[0,'m'],[4,'m'],[5,'M'],[3,'m']], [[0,'m'],[5,'M'],[3,'m'],[4,'M']], [[5,'M'],[6,'M'],[0,'m'],[0,'m']], [[0,'m'],[2,'M'],[6,'M'],[5,'M']], [[3,'m'],[0,'m'],[5,'M'],[4,'M']]],
      chill: [[[0,'m7'],[3,'m7'],[5,'maj7'],[4,'m7']], [[0,'m7'],[5,'maj7'],[2,'maj7'],[6,'7']], [[3,'m7'],[4,'m7'],[0,'m7'],[0,'m7']], [[5,'maj7'],[3,'m7'],[0,'m7'],[0,'m7']]],
      happy: [[[5,'M'],[6,'M'],[2,'M'],[0,'m']], [[2,'M'],[6,'M'],[0,'m'],[5,'M']]],
      epic: [[[0,'m'],[5,'M'],[2,'M'],[6,'M']], [[5,'M'],[6,'M'],[0,'m'],[0,'m']], [[0,'m'],[6,'M'],[5,'M'],[4,'M']], [[0,'m'],[3,'m'],[6,'M'],[2,'M']]],
      rnb: [[[0,'m7'],[3,'m7'],[6,'7'],[2,'maj7']], [[5,'maj7'],[4,'m7'],[0,'m7'],[0,'m7']], [[0,'m7'],[6,'7'],[5,'maj7'],[4,'m7']]]
    },
    maj: {
      dark: [[[0,'M'],[3,'m'],[0,'M'],[3,'m']], [[5,'m'],[2,'m'],[3,'M'],[0,'M']], [[5,'m'],[3,'M'],[4,'M'],[2,'m']]],
      sad: [[[5,'m'],[3,'M'],[0,'M'],[4,'M']], [[0,'M'],[2,'m'],[5,'m'],[3,'M']], [[3,'M'],[0,'M'],[5,'m'],[4,'M']]],
      chill: [[[0,'maj7'],[5,'m7'],[1,'m7'],[4,'7']], [[3,'maj7'],[2,'m7'],[5,'m7'],[0,'maj7']], [[1,'m7'],[4,'7'],[0,'maj7'],[0,'maj7']], [[0,'maj7'],[3,'maj7'],[0,'maj7'],[3,'maj7']]],
      happy: [[[0,'M'],[4,'M'],[5,'m'],[3,'M']], [[0,'M'],[3,'M'],[5,'m'],[4,'M']], [[0,'M'],[5,'m'],[3,'M'],[4,'M']], [[3,'M'],[0,'M'],[4,'M'],[5,'m']]],
      epic: [[[0,'M'],[4,'M'],[5,'m'],[3,'M']], [[3,'M'],[4,'M'],[5,'m'],[5,'m']], [[5,'m'],[3,'M'],[0,'M'],[4,'M']]],
      rnb: [[[3,'maj7'],[4,'7'],[2,'m7'],[5,'m7']], [[1,'m7'],[4,'7'],[0,'maj7'],[5,'m7']], [[0,'maj7'],[2,'m7'],[3,'maj7'],[4,'7']]]
    }
  };
  var MOOD_MODE = { dark: 'min', sad: 'min', chill: 'min', happy: 'maj', epic: 'min', rnb: 'maj' };

  var keySel = root.querySelector('[data-ch-key]'), bpmIn = root.querySelector('[data-ch-bpm]'), grid = root.querySelector('[data-ch-grid]');
  var playBtn = root.querySelector('[data-ch-play]'), copyBtn = root.querySelector('[data-ch-copy]'), midiBtn = root.querySelector('[data-ch-midi]');
  var key = 9, mode = 'min', mood = 'dark', prog = [], lastTpl = -1;

  function names() { return FLAT_KEYS[mode].indexOf(key) > -1 ? FLAT : SHARP; }
  function chord(deg, q) {
    var rootPc = (key + SCALE[mode][deg]) % 12;
    var nm = names()[rootPc] + SUF[q];
    var up = q === 'M' || q === '7' || q === 'maj7';
    var rn = up ? ROMAN[deg] : ROMAN[deg].toLowerCase();
    if (q === 'dim') rn += '°'; if (q === '7') rn += '7'; if (q === 'maj7') rn += 'maj7'; if (q === 'm7') rn += '7';
    return { pc: rootPc, q: q, name: nm, roman: rn };
  }
  function voice(list) {
    var prev = null;
    return list.map(function (c) {
      var ints = Q[c.q], best = null, bestD = 1e9;
      for (var inv = 0; inv < ints.length; inv++) {
        var notes = ints.map(function (iv, i) { return 60 + c.pc + iv + (i < inv ? 12 : 0); });
        while (Math.min.apply(null, notes) > 64) notes = notes.map(function (n) { return n - 12; });
        while (Math.min.apply(null, notes) < 53) notes = notes.map(function (n) { return n + 12; });
        var center = notes.reduce(function (a, b) { return a + b; }, 0) / notes.length;
        var d = prev === null ? Math.abs(center - 65) : Math.abs(center - prev);
        if (d < bestD) { bestD = d; best = notes; }
      }
      prev = best.reduce(function (a, b) { return a + b; }, 0) / best.length;
      c.notes = best.sort(function (a, b) { return a - b; }); c.bass = 36 + c.pc;
      return c;
    });
  }

  function gen() {
    var list = P[mode][mood] || P[mode].dark, i;
    do { i = Math.floor(Math.random() * list.length); } while (list.length > 1 && i === lastTpl);
    lastTpl = i;
    prog = voice(list[i].map(function (x) { return chord(x[0], x[1]); }));
    render();
  }

  function render() {
    grid.innerHTML = '';
    prog.forEach(function (c, i) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'ch-card'; b.setAttribute('data-i', i);
      b.innerHTML = '<span class="ch-name"></span><span class="ch-roman"></span>';
      b.querySelector('.ch-name').textContent = c.name; b.querySelector('.ch-roman').textContent = c.roman;
      b.addEventListener('click', function () { audio(); hit(c, ac.currentTime + 0.02, 1.4); flash(i); });
      grid.appendChild(b);
    });
  }
  function flash(i) { grid.querySelectorAll('.ch-card').forEach(function (el, j) { el.classList.toggle('is-on', j === i); }); }

  var ac = null, out = null, timer = 0, playing = false, nextT = 0, bar = 0;
  function audio() {
    if (!ac) { ac = new (window.AudioContext || window.webkitAudioContext)(); out = ac.createGain(); out.gain.value = 0.5; out.connect(ac.destination); }
    if (ac.state === 'suspended') ac.resume();
  }
  function hz(m) { return 440 * Math.pow(2, (m - 69) / 12); }
  function hit(c, t, dur) {
    c.notes.forEach(function (n) {
      [['triangle', 0.12, 1], ['sine', 0.05, 2]].forEach(function (o) {
        var osc = ac.createOscillator(), g = ac.createGain(), f = ac.createBiquadFilter();
        osc.type = o[0]; osc.frequency.value = hz(n) * o[2]; f.type = 'lowpass'; f.frequency.value = 2400;
        g.gain.setValueAtTime(0.0001, t); g.gain.linearRampToValueAtTime(o[1], t + 0.015); g.gain.exponentialRampToValueAtTime(o[1] * 0.35, t + 0.5); g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
        osc.connect(f).connect(g).connect(out); osc.start(t); osc.stop(t + dur + 0.05);
      });
    });
    var b = ac.createOscillator(), bg = ac.createGain(); b.type = 'sine'; b.frequency.value = hz(c.bass);
    bg.gain.setValueAtTime(0.0001, t); bg.gain.linearRampToValueAtTime(0.35, t + 0.02); bg.gain.exponentialRampToValueAtTime(0.0001, t + dur);
    b.connect(bg).connect(out); b.start(t); b.stop(t + dur + 0.05);
  }
  function bpm() { var v = parseInt(bpmIn.value, 10); return isNaN(v) ? 90 : Math.max(50, Math.min(200, v)); }
  function schedule() {
    var barLen = 4 * 60 / bpm();
    while (nextT < ac.currentTime + 0.25) {
      var i = bar % prog.length, c = prog[i];
      hit(c, nextT, barLen);
      (function (i, t) { setTimeout(function () { if (playing) flash(i); }, Math.max(0, (t - ac.currentTime) * 1000)); })(i, nextT);
      nextT += barLen; bar++;
    }
    timer = setTimeout(schedule, 60);
  }
  function setPlay(on) {
    playing = on; playBtn.textContent = on ? T.stop : T.play; playBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
    clearTimeout(timer);
    if (on) { audio(); bar = 0; nextT = ac.currentTime + 0.05; schedule(); } else { flash(-1); if (out) { out.gain.setTargetAtTime(0, ac.currentTime, 0.03); var o = out; out = ac.createGain(); out.gain.value = 0.5; out.connect(ac.destination); setTimeout(function () { o.disconnect(); }, 300); } }
  }
  playBtn.addEventListener('click', function () { setPlay(!playing); });

  function vlq(n) { var b = [n & 0x7f]; while ((n >>= 7)) b.unshift((n & 0x7f) | 0x80); return b; }
  function track(events) {
    var data = [];
    events.forEach(function (e) { data = data.concat(vlq(e[0]), e[1]); });
    data = data.concat([0, 0xff, 0x2f, 0]);
    var len = data.length;
    return [0x4d, 0x54, 0x72, 0x6b, (len >>> 24) & 255, (len >>> 16) & 255, (len >>> 8) & 255, len & 255].concat(data);
  }
  function str(s) { return Array.prototype.map.call(unescape(encodeURIComponent(s)), function (c) { return c.charCodeAt(0); }); }
  function midi() {
    var ppq = 480, barT = ppq * 4, us = Math.round(60000000 / bpm());
    var t0 = [[0, [0xff, 0x51, 3, (us >> 16) & 255, (us >> 8) & 255, us & 255]], [0, [0xff, 0x58, 4, 4, 2, 24, 8]], [0, [0xff, 0x03].concat(vlq(6), str('Chords'))]];
    var t1 = [[0, [0xff, 0x03].concat(vlq(4), str('Bass'))]];
    prog.forEach(function (c) {
      c.notes.forEach(function (n, k) { t0.push([0, [0x90, n, 88]]); });
      c.notes.forEach(function (n, k) { t0.push([k === 0 ? barT : 0, [0x80, n, 0]]); });
      t1.push([0, [0x91, c.bass, 96]]); t1.push([barT, [0x81, c.bass, 0]]);
    });
    var head = [0x4d, 0x54, 0x68, 0x64, 0, 0, 0, 6, 0, 1, 0, 2, (ppq >> 8) & 255, ppq & 255];
    var bytes = new Uint8Array(head.concat(track(t0), track(t1)));
    var a = document.createElement('a');
    a.href = URL.createObjectURL(new Blob([bytes], { type: 'audio/midi' }));
    a.download = 'NameOnTheBeat ' + prog.map(function (c) { return c.name; }).join('-') + ' ' + bpm() + 'bpm.mid';
    a.style.display = 'none'; root.appendChild(a); a.click(); setTimeout(function () { a.remove(); }, 1000);
  }
  midiBtn.addEventListener('click', midi);
  copyBtn.addEventListener('click', function () {
    var txt = prog.map(function (c) { return c.name; }).join(' - ');
    if (navigator.clipboard) navigator.clipboard.writeText(txt).then(function () { copyBtn.textContent = T.copied; setTimeout(function () { copyBtn.textContent = T.copy; }, 1200); });
  });

  function fillKeys() {
    keySel.innerHTML = '';
    for (var k = 0; k < 12; k++) {
      var nm = (FLAT_KEYS[mode].indexOf(k) > -1 ? FLAT : SHARP)[k] + (mode === 'min' ? 'm' : '');
      var o = document.createElement('option'); o.value = k; o.textContent = nm; if (k === key) o.selected = true; keySel.appendChild(o);
    }
  }
  function setMode(m) {
    mode = m; root.querySelectorAll('[data-ch-mode]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-ch-mode') === m ? 'true' : 'false'); });
    fillKeys();
  }
  root.querySelectorAll('[data-ch-mood]').forEach(function (b) {
    b.addEventListener('click', function () {
      mood = b.getAttribute('data-ch-mood');
      root.querySelectorAll('[data-ch-mood]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      setMode(MOOD_MODE[mood]); lastTpl = -1; gen();
    });
  });
  root.querySelectorAll('[data-ch-mode]').forEach(function (b) { b.addEventListener('click', function () { setMode(b.getAttribute('data-ch-mode')); lastTpl = -1; gen(); }); });
  keySel.addEventListener('change', function () { key = parseInt(keySel.value, 10); prog = voice(prog.map(function (c) { return c; })); var tpl = P[mode][mood] || P[mode].dark; prog = voice(tpl[lastTpl].map(function (x) { return chord(x[0], x[1]); })); render(); });
  root.querySelector('[data-ch-go]').addEventListener('click', gen);
  setMode('min'); gen();
})();
